import React from "react";
import { Container, Stack, Text, Title } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import styles from "./PayrollPage.module.css";

interface PayrollAccessRestrictedProps {
  /** The signed-in user's role; picks who they should contact. */
  role: string | undefined;
}

/**
 * Shown in place of the Payroll page when payroll isn't available to this
 * user: the workflow is unavailable, the location has no RollFi company, or a
 * staff member has no RollFi worker yet (see utils/payrollAccess). The nav
 * entry is hidden in those cases too, so this mostly catches deep links.
 */
export const PayrollAccessRestricted: React.FC<
  PayrollAccessRestrictedProps
> = ({ role }) => {
  const isOwnerOrManager = role === "Owner" || role === "Manager";
  return (
    <Container fluid className={styles.container}>
      <Stack gap="md" align="center" mt="xl">
        <IconInfoCircle size={48} color="var(--mantine-color-gray-6)" />
        <Title order={2}>Access Restricted</Title>
        <Text size="md" c="dimmed" ta="center" maw={500}>
          {isOwnerOrManager
            ? "Payroll has not been set up for this business. Please contact the business owner to enable payroll features."
            : "You don't have access to payroll features. Please contact your manager or owner to set up your payroll account."}
        </Text>
      </Stack>
    </Container>
  );
};

export default PayrollAccessRestricted;
